import { TEST_BUCKET } from '../utils/constants';

export interface IFileConfig {
  allowedFileExtensionList: string[];
  allowedMimeTypeList: string[];
  canUploadMultiple: boolean;
}

export class FileConfig implements IFileConfig {
  allowedFileExtensionList: string[] = [];
  allowedMimeTypeList: string[] = [];
  canUploadMultiple: boolean = false;

  constructor(configOverride?: Partial<IFileConfig>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}

export interface IEncodedImageDTO {
  base64: string;
  contentType: string;
}

export interface IValidationMessage {
  extensionIcon?: string;
  message: string;
}

export enum FileTypes {
  IMAGE = 'Image',
  VIDEO = 'Video',
  AUDIO = 'Audio',
  DOCUMENT = 'Document',
}

export interface IFileUpload {
  id: string;
  fileName: string;
  fileType: FileTypes;
  fileMimeType: string;
  fileSize: number;
  bucket: string;
  location?: string;
  signedUrl?: string;
  cdnUrl?: string;
}

export class FileUpload implements IFileUpload {
  id: string = '';
  fileName: string = '';
  fileType: FileTypes;
  fileMimeType: string = '';
  fileSize: number = 0;
  bucket: string = TEST_BUCKET;
  location?: string = '';
  signedUrl?: string = '';
  cdnUrl?: string = '';

  constructor(configOverride?: Partial<IFileUpload>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
